import { Button, Form, Input, Modal, Select, message } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { ReferenceRateBaseOptions } from "constants/Constants";
import { useEffect, useState } from "react";
import HousingCompanyService from "services/services/HousingCompanyService";
import { convertToObjectKeyString, TranslateString } from "Utils/Common";
import { useIntl } from "react-intl";

const NewLoanModal = (props: any) => {
  const [form] = Form.useForm();
  const [editId, setEditId] = useState<any>();
  const [customerOption, setCustomerOption] = useState<any>();
  const [editValue, setEditValue] = useState<any>({
    loan_data_customerid: "",
    loan_data_name: "",
    loan_data_agreement: "",
    loan_data_interest_rate_bond: "",
    loan_data_loan_type: "",
    loan_data_agreed_shortening_period: "",
    loan_data_purpose: "",
    loan_invoicing_model: "",
    loan_time: "",
    
  });
  // const [searchData, setSearchData] = useState<any>({ bank_name: "", city_id: "", city_name: "", loan_name: "", estimated_amount_capital: "", loan_reason: "", sort: "asc", sort_by: "" });
  const [confirmLoading, setConfirmLoading] = useState<any>(false);
  const intl = useIntl();

  useEffect(() => {
    getCustomerList();
  }, []);

  const paymentMethods: any = [
    {
      label: "tasalyhennys",
      value: "tasalyhennys",
    },
    {
      label: "annuiteetti",
      value: "annuiteetti",
    },
    {
      label: "tasaerä",
      value: "tasaerä",
    },
  ];
//   const invoiceTypeOptions: any = [
//     { label: "Recurring", value: "recurring" },
//     { label: "Non-recurring", value: "non_recurring" },
//   ];
const invoiceTypeOptions = [
  {
    label: intl.formatMessage({ id: "Recurring" }),
    value: "Recurring",
  },
  {
    label: intl.formatMessage({ id: "Non-Recurring" }),
    value: "Non-Recurring",
  },
];

  const onFormSubmit = async (formData: any) => {
    setConfirmLoading(true);
    formData.loan_data_customername =
      customerOption?.find(
        (f: any) =>
          f.value?.toString() === formData.loan_data_customerid?.toString(),
      )?.customer_name || "";
    formData.loan_data_agreement = formData.loan_data_agreement.replace(
      ",",
      ".",
    );
    formData.loan_data_agreed_shortening_period =
      formData?.loan_data_agreed_shortening_period?.replace(",", ".") || 0;
    formData.loan_data_name = "Uusi laina: " + formData.loan_data_name;

    let response: any = await HousingCompanyService?.saveCustomerLoan(formData);
    if (response?.data?.code === 200) {
      message.success(
        intl.formatMessage({
          id: convertToObjectKeyString(response?.data?.msg),
        }),
      );
      props.setCreateLoanOpen(!props?.createLoanOpen);
      props.getAllTargetGroup();
      onReset();
    } else {
      message.error(
        intl.formatMessage({
          id: convertToObjectKeyString(response?.data?.msg),
        }),
      );
    }
    setEditId("");
    setEditValue({
      loan_data_customerid: "",
      loan_data_name: "",
      loan_data_agreement: "",
      loan_data_interest_rate_bond: "",
      loan_data_loan_type: "",
      loan_data_agreed_shortening_period: "",
      loan_data_purpose: "",
      loan_invoicing_model: "",
        loan_time: "",
    });
    setConfirmLoading(false);
  };

  const onReset = () => {
    form.resetFields();
  };

  const getCustomerList = async (val: any = "") => {
    let search: any = {
      customer_id_name: val,
      // customer_id : val,
    };

    let customerList: any = await HousingCompanyService?.getNewLoanCustomerList(
      val ? search : {},
    );
    if (customerList?.data?.code === 200) {
      let customerListData: any = customerList?.data?.data?.map(
        (e: any, i: any) => {
          return {
            label: e?.customer_id + "-" + e?.customer_name,
            customer_name: e?.customer_name,
            value: e?.customer_id,
          };
        },
      );
      setCustomerOption(customerListData);
    }
  };

  return (
    <>
      <Modal
        title={
          editId
            ? TranslateString("edit_new_loan")
            : TranslateString("create_new_loan")
        }
        open={props?.createLoanOpen}
        footer={false}
        destroyOnClose
        closable={false}
      >
        <Form
          form={form}
          requiredMark={false}
          onFinish={onFormSubmit}
          layout="vertical"
          initialValues={{
            loan_data_customerid: editValue?.loan_data_customerid,
            loan_data_name: editValue?.loan_data_name,
            loan_data_agreement: editValue?.loan_data_agreement,
            loan_data_interest_rate_bond:
              editValue?.loan_data_interest_rate_bond,
            loan_data_loan_type: editValue?.loan_data_loan_type,
            loan_data_agreed_shortening_period:
              editValue?.loan_data_agreed_shortening_period,

            loan_data_purpose: editValue?.loan_data_purpose,
            loan_invoicing_model: editValue?.loan_invoicing_model,
            loan_time: editValue?.loan_time,
          }}
        >
          <Form.Item
            label={
              <>
                <span>{TranslateString("housing_company")}</span>
                <span className="text-danger">*</span>
              </>
            }
            name="loan_data_customerid"
            rules={[
              {
                required: true,
                message: TranslateString("please_select_housing_company"),
              },
            ]}
            className="mb-1"
          >
            <Select
              placeholder={TranslateString("select")}
              showSearch
              filterOption={(input: any, option: any) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              onSearch={getCustomerList}
              className="w-100"
              allowClear
              options={customerOption}
            />
          </Form.Item>
          <Form.Item
            label={
              <>
                <span>{TranslateString("name_of_the_loan_2")}</span>
                <span className="text-danger">*</span>
              </>
            }
            name="loan_data_name"
            rules={[
              {
                required: true,
                message: TranslateString("please_enter_name_of_the_loan"),
              },
            ]}
            className="mb-1"
          >
            <Input addonBefore={TranslateString("new_loan")} />
          </Form.Item>
          <Form.Item
            label={
              <>
                <span>{TranslateString("capital_2")}</span>
                <span className="text-danger">*</span>
              </>
            }
            name="loan_data_agreement"
            rules={[
              {
                required: true,
                message: TranslateString("please_enter_number"),
                pattern: new RegExp(/^[\d,\s]+$/),
              },
            ]}
            className="mb-1"
          >
            <Input />
          </Form.Item>
          <Form.Item
  label={
    <>
      <span>{TranslateString("loan_time")}</span>
      <span className="text-danger">*</span>
    </>
  }
  name="loan_time"
  rules={[
    {
      required: true,
      message: TranslateString("please_enter_number"),
    },
    {
      pattern: new RegExp(/^\d{1,2}$/),
      message: "Only 1 or 2 digit number allowed",
    },
  ]}
  className="mb-1"
>
  <Input
    maxLength={2}
    onKeyPress={(e) => {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    }}
  />
</Form.Item>
          <Form.Item
            label={
              <>
                <span>{TranslateString("Requested payment method")}</span>
                {/* <span className="text-danger">*</span> */}
              </>
            }
            name="loan_data_loan_type"
            // rules={[{ required: true, message: TranslateString('please_select_payment_method') }]}
            className="mb-1"
          >
            <Select
              placeholder={TranslateString("select")}
              showSearch
              filterOption={(input: any, option: any) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              className="w-100"
              allowClear
              options={paymentMethods}
            />
          </Form.Item>

          <Form.Item
            label={
              <>
                <span>{TranslateString("Requested Euribor")}</span>
                {/* <span className="text-danger">*</span> */}
              </>
            }
            name="loan_data_interest_rate_bond"
            // rules={[{ required: true, message: TranslateString('please_select_reference_rate') }]}
            className="mb-1"
          >
            <Select
              placeholder={TranslateString("select")}
              showSearch
              // filterOption={(input: any, option: any) =>
              //     (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              // }
              className="w-100"
              allowClear
              options={ReferenceRateBaseOptions}
            />
          </Form.Item>
          <Form.Item
            label={
              <>
                <span>{TranslateString("Requested payment interval")}</span>
                {/* <span className="text-danger">*</span> */}
              </>
            }
            name="loan_data_agreed_shortening_period"
            // rules={[
            //     {
            //         required: true,
            //         message: TranslateString('please_enter_number'),
            //         pattern: new RegExp(/^[\d,\s]+$/)
            //     },
            //     {
            //         message: TranslateString('maximum_value_12'),
            //         validator: (_, value) => {
            //             if (value<=12) {
            //                 return Promise.resolve();
            //             } else {
            //                 return Promise.reject(TranslateString('maximum_value_12'));
            //             }
            //         }
            //     },
            //     {
            //         message: TranslateString('minimum_value_1'),
            //         validator: (_, value) => {
            //             if (value>=1) {
            //                 return Promise.resolve();
            //             } else {
            //                 return Promise.reject(TranslateString('minimum_value_1'));
            //             }
            //         }
            //     }
            // ]}
            className="mb-1"
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={
              <>
                <span>{TranslateString("Purpose of the loan")}</span>
              </>
            }
            name="loan_data_purpose"
            // rules={[{ required: false, message: TranslateString('please_enter_reason_for_the_loan')}]}
            className="mb-1"
          >
            <TextArea rows={4} />
          </Form.Item>
          <Form.Item
            label={
              <>
                <span>{TranslateString("loan_invoicing_model")}</span>
                <span className="text-danger">*</span>
              </>
            }
            name="loan_invoicing_model"
            rules={[
              { required: true, message: "Please select Invoicing model" },
            ]}
            className="mb-1"
          >
            <Select
              placeholder="Select"
              className="w-100"
              allowClear
              options={invoiceTypeOptions}
            />
          </Form.Item>
          <div className="d-flex justify-content-end mt-2">
            <Button
              htmlType="button"
              className="btn btn-sm btn-secondary px-4"
              onClick={() => {
                props.setCreateLoanOpen(!props?.createLoanOpen);
                setEditId("");
                onReset();
                setEditValue("");
              }}
            >
              {TranslateString("cancel")}
            </Button>
            &nbsp;
            <Button
              htmlType="submit"
              className="btn btn-sm btn-light px-3 cu-btn-green"
              disabled={confirmLoading}
            >
              {confirmLoading
                ? TranslateString("Please Wait")
                : TranslateString("save")}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default NewLoanModal;
